@if (data().length > 0) { @for (message of data(); track trackByFn(i, message); let
i = $index) {
<av-card-row class="fx-row fx-align-center fx-flex-1 content">
  <div>
    @if (isNewSender(message, i)) {
    <div>
      <small
        ><b>{{ message.name }}</b></small
      >
    </div>
    }
    <div class="message">{{ message.translation || message.transcript }}</div>
  </div>
</av-card-row>
} } @if (data().length === 0) {
<div class="container-pad-md text-muted" translate>No data found</div>
}
